module.exports = __webpack_public_path__ + "img/Olga.fbe76ba4.jpg";